<template>
  <div class="zpc-uploader">
    <el-upload
      :class="`limit-${fileList.length}`"
      :multiple="false"
      action=""
      :file-list="fileList"
      accept="image/*"
      list-type="picture-card"
      :http-request="handleUpload"
      :on-remove="handleRemove"
      :on-preview="hanlePreview"
      :limit="limit"
    >
      <i slot="default" class="el-icon-plus"></i>
    </el-upload>
    <el-image-viewer
      v-if="showPreview"
      :on-close="handleClose"
      :url-list="previewList"
    />
  </div>
</template>
<script>
import axios from 'axios'
import imageCompressor from '@/libs/compressor'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import _ from 'lodash'
import { bind, unbind } from '@/utils/eventBinder'

export default {
  components: { ElImageViewer },
  props: {
    limit: {
      type: Number,
      default () {
        return 1
      }
    },
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      showPreview: false,
      previewList: [],
      fileList: this.value
    }
  },
  watch: {
    value: {
      handler (val) {
        this.fileList = val
      },
      immediate: true
    }
  },
  mounted () {
    bind(window, 'paste', this.readImageFromClipboard)
  },
  beforeDestroy () {
    unbind(window, 'paste', this.readImageFromClipboard)
  },
  methods: {
    handleUpload (ev) {
      imageCompressor(ev.file).then(cFile => {
        const formData = new FormData()
        formData.append('file', cFile, ev.file.name)
        axios.post('https://crm.zhaopeiyun.com/pub/file/upload/image?key=176ebdaec845dc55e891fd82fb8895a8&category=zpccrm&cdn=1', formData).then((resp) => {
          const newFile = { url: resp.data.data.icon }
          const data = [...this.fileList]
          data.push(newFile)
          this.$emit('input', data)
        }).catch(() => {
          this.$message.error('图片上传失败')
        })
      }).catch(() => {
        this.$message.error('图片文件无法压缩处理')
      })
    },
    handleRemove (file, fileList) {
      this.$emit('input', fileList)
    },
    hanlePreview (file) {
      const previewList = this.fileList.map(e => e.url)
      _.remove(previewList, o => o === file.url)
      previewList.unshift(file.url)
      this.previewList = previewList
      this.showPreview = true
    },
    handleClose () {
      this.showPreview = false
    },
    readImageFromClipboard (ev) {
      const { items } = (ev.clipboardData || ev.originalEvent.clipboardData)
      const fileTypes = []
      items.forEach(item => {
        fileTypes.push(item.type)
      })
      if (fileTypes[0].indexOf('image') === -1) {
        return
      }
      if (items && items.length) {
        items.forEach(item => {
          if (item.type.indexOf('image') > -1) {
            const file = item.getAsFile()
            imageCompressor(file).then(cFile => {
              const formData = new FormData()
              formData.append('file', cFile, cFile.name)
              axios.post('https://erp.zhaopeiyun.com/pub/file/upload/image?key=176ebdaec845dc55e891fd82fb8895a8&category=zpcerp&cdn=1', formData).then((resp) => {
                const newFile = { url: resp.data.data.icon }
                const data = [...this.fileList]
                data.push(newFile)
                this.$emit('input', data)
              }).catch(() => {
                this.$message.error('图片上传失败')
              })
            }).catch((error) => {
              console.log(error)
              this.$message.error('图片文件无法压缩处理')
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="stylus">
.zpc-uploader
  .el-upload--picture-card
    width 60px
    height 60px
    line-height 58px
    position relative
    i.el-icon-plus
      position absolute
      display block
      height 28px
      width 28px
      top 0
      bottom 0
      left 0
      right 0
      margin auto
  .el-upload-list--picture-card
    .el-upload-list__item
      height auto
      top 0
      bottom 0
      margin auto
      width: 60px
      height: 60px
      margin-right 8px
    .el-upload-list__item-actions
      font-size: 12px
      > span + span
        margin-left: 8px
</style>
